import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormFillerComponent } from "../../../../../common/modules/form-actions/common/components/form-filler/form-filler.component";
import { ActivatedRoute, Router } from '@angular/router';
import { IFormModel } from 'src/app/common/apis/form/model/form.model';

import { FormBettingApiService } from 'src/app/common/apis/form/form-betting-api.service';
import { SimulateResultsStateService } from './simulate-results-state.service';
import { IFormBettings } from '@oogaday/shared';

@Component({
  selector: 'oo-simulate-results-form-filler',
  imports: [FormFillerComponent],
  templateUrl: './simulate-results-form-filler.component.html',
  styleUrl: './simulate-results-form-filler.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimulateResultsFormFillerComponent { 
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly formBettingApi = inject(FormBettingApiService);
  private readonly simulateResultsStateService = inject(SimulateResultsStateService);

  formId = this.route.snapshot.paramMap.get('formId')!;
  compGroupId = this.route.snapshot.paramMap.get('compGroupId')!;
  
  dataFetcher = async (): Promise<IFormModel> => {
    const form = await this.formBettingApi.getFormById(
      this.compGroupId,
      this.formId,
      ['userBetting', 'metadata', 'config', 'userBettingId'],
    );

    const simulatedResults = this.simulateResultsStateService.getSimulateResults(this.compGroupId, this.formId);

    return simulatedResults ? {...form, bettingResult: simulatedResults.result} : form;
  }
  
  onSubmitCallback = async (betting: IFormBettings<any>): Promise<boolean> => {
    const response = await this.formBettingApi.simulateBettingResults(this.compGroupId, this.formId, betting);
    this.simulateResultsStateService.setSimulatedResults(this.compGroupId, this.formId, {
      result: betting,
      bettingResults: response,
    });

    return true;
  }

  afterSave(): void {
    this.router.navigate([`../../formResults/${this.formId}`], {
      relativeTo: this.route,
    });
  }
}
